import {Typography} from '@mui/material';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {AlertInfo} from '../AlertInfo';
import {AlertCancelledType} from './types';

const {cancelIn, cancelContract} = translations['pt-br'].commons;

const AlertCancelled = ({dtCancelamento}: AlertCancelledType) => (
	<AlertInfo.Root severity="warning" sx={{padding: '0 0 0 8px'}}>
		<AlertInfo.Description>
			<Typography variant="body2">
				{dtCancelamento ? cancelIn : cancelContract}
				<b>{dtCancelamento}</b>
			</Typography>
		</AlertInfo.Description>
	</AlertInfo.Root>
);

export {AlertCancelled};
